export default __webpack_public_path__ + "static/media/Montserrat-Light.150ab76c.eot";